<div class="static-card-container">
  @if (researchCards.length) {
    <div class="uilab-card uilab-card--static no-hover">
      <div class="uilab-card--content uilab-card--filter">
        <form [formGroup]="cardFilterForm">
          <div id="researchType">
            <uilab-mat-chip-listbox
              #chips
              aria-label="Research type selection"
              selectable
              [formControl]="researchType"
              >
              @for (type of researchTypes; track type) {
                <uilab-mat-chip-option
                  [value]="type.value"
                  >
                  {{ type.label }}
                </uilab-mat-chip-option>
              }
            </uilab-mat-chip-listbox>
          </div>
          <div id="researchProduct">
            <uilab-mat-form-field appearance="fill" id="category">
              <uilab-mat-label>Products</uilab-mat-label>
              <uilab-mat-select [formControl]="researchProduct">
                <uilab-mat-option [value]="''">All</uilab-mat-option>
                @for (
                  product of researchProducts;
                  track product
                  ) {
                  <uilab-mat-option [value]="product.label">{{
                    product.label
                  }}</uilab-mat-option>
                }
              </uilab-mat-select>
            </uilab-mat-form-field>
          </div>
        </form>
      </div>
    </div>

    @if (filtered.length) {
      @for (card of filtered; track card) {
        <app-research-card [card]="card"></app-research-card>
      }
    } @else {
      <div class="uilab-card uilab-card--static">
        <div class="uilab-card--content">
          <header class="uilab-card--header">
            <h4>No matches</h4>
          </header>
          Sorry, no studies match your criteria.
        </div>
      </div>
    }
  }
</div>
